"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14953%3A7558))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:37:20.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRSave = createSVGIcon(
  <path
    d="M4.75 3.088V20.25l7.192-6.672 7.308 6.672V3.088a.337.337 0 0 0-.337-.338H5.088a.337.337 0 0 0-.338.337Z"
    stroke="currentColor"
    strokeWidth="1.5"
  />,
  "BSRSave",
  (strictLocalize) => ({
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "Mrt+XC",
      defaultMessage: "Save",
      description: {
        text: "Message for screen readers when only the Save icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
